import { Extension } from "@tiptap/core";

import "tippy.js/dist/tippy.css";
import "./styles.css";

import { WaffleMenuPlugin } from "./plugin";

/**
 * Options for configuring the NodeHover extension
 */
export type NodeHoverOptions = {
  /**
   * CSS class to apply to the hovered node
   * @default "node-hover-decoration"
   */
  className: string;

  /**
   * Node types to apply the hover effect to
   * If empty, applies to all nodes
   * @default []
   */
  nodeTypes: string[];

  /**
   * Wrapper elements that should not allow the menu to show within the wrapper
   * @default []
   * @example ["nw-note", "blockquote", "nw-validation-box"]
   */
  wrapperTags: string[];
};

/**
 * NodeHover extension that adds a decoration to nodes when hovered and adds decorations accordingly.
 */
export const WaffleMenuExtension = Extension.create<NodeHoverOptions>({
  name: "waffleMenu",

  addOptions() {
    return {
      className: "node-hover-decoration",
      nodeTypes: [],
      wrapperTags: [],
    };
  },

  addProseMirrorPlugins() {
    const { nodeTypes, wrapperTags } = this.options;
    const editor = this.editor;

    return [new WaffleMenuPlugin(editor, nodeTypes, wrapperTags).plugin];
  },
});
